import { useEntity } from '@backstage/plugin-catalog-react';
import { usePermission } from '@backstage/plugin-permission-react';
import {
  storageAccountSASCreatePermissionDv,
  storageAccountSASCreatePermissionPp,
  storageAccountSASCreatePermissionPr,
  storageContainerSASCreatePermissionDv,
  storageContainerSASCreatePermissionPp,
  storageContainerSASCreatePermissionPr,
  storageAccountQueueClearPermissionDv,
  storageAccountQueueClearPermissionPp,
  storageAccountQueueClearPermissionNp,
} from '@internal/plugin-storage-account-common';

// NOTE: Update this annotation key to match the one used on storageaccount entities in npet-idp
const ENVIRONMENT_ANNOTATION = 'nestle.com/environment';

export const useStoragePermissions = () => {
  const { entity } = useEntity();

  const storageAccountSASPermissionDvResult = usePermission({
    permission: storageAccountSASCreatePermissionDv,
  });
  const storageAccountSASPermissionPpResult = usePermission({
    permission: storageAccountSASCreatePermissionPp,
  });
  const storageAccountSASPermissionPrResult = usePermission({
    permission: storageAccountSASCreatePermissionPr,
  });

  const storageContainerSASPermissionDvResult = usePermission({
    permission: storageContainerSASCreatePermissionDv,
  });
  const storageContainerSASPermissionPpResult = usePermission({
    permission: storageContainerSASCreatePermissionPp,
  });
  const storageContainerSASPermissionPrResult = usePermission({
    permission: storageContainerSASCreatePermissionPr,
  });

  const accountSASPermission = {
    dv: storageAccountSASPermissionDvResult.allowed,
    pp: storageAccountSASPermissionPpResult.allowed,
    pr: storageAccountSASPermissionPrResult.allowed,
  };

  const containerSASPermission = {
    dv: storageContainerSASPermissionDvResult.allowed,
    pp: storageContainerSASPermissionPpResult.allowed,
    pr: storageContainerSASPermissionPrResult.allowed,
  };

  const env = entity.metadata.annotations?.[ENVIRONMENT_ANNOTATION] || '';

  const hasAccountSASPermission = Boolean(
    accountSASPermission[env as keyof typeof accountSASPermission],
  );

  const hasContainerSASPermission = Boolean(
    containerSASPermission[env as keyof typeof containerSASPermission],
  );

  return { hasAccountSASPermission, hasContainerSASPermission };
};

export const useQueuePermissions = () => {
  const { entity } = useEntity();

  const clearQueuePermissionDvResult = usePermission({
    permission: storageAccountQueueClearPermissionDv,
  });
  const clearQueuePermissionPpResult = usePermission({
    permission: storageAccountQueueClearPermissionPp,
  });
  const clearQueuePermissionNpResult = usePermission({
    permission: storageAccountQueueClearPermissionNp,
  });

  const clearPermission = {
    dv: clearQueuePermissionDvResult.allowed,
    pp: clearQueuePermissionPpResult.allowed,
    np: clearQueuePermissionNpResult.allowed,
    pr: false,
  };

  const env = entity.metadata.annotations?.[ENVIRONMENT_ANNOTATION] || '';

  const hasClearPermission = Boolean(
    clearPermission[env as keyof typeof clearPermission],
  );

  return { hasClearPermission, env };
};
